import {Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, Output, SimpleChanges,} from '@angular/core';
import {
    DsButtonModule,
    DsCheckboxModule,
    DsFormFieldModule,
    DsLoadingAreaConfiguration,
    DsLoadingAreaModule,
    DsLoadingAreaService,
    DsProgressCircleModule,
    DsSelectModule,
} from '@bmw-ds/components';
import {ModelOption, ModelOptionsResponse, ModelOptionsService,} from 'src/app/services/model-options.service';
import {CriteriaResponse, DealerBrand, DealerModel, StorageLocation, Version,} from 'src/app/models/criteria.model';
import {SelectListOption} from 'src/app/models/option-selected.model';
import {RequestPayload} from 'src/app/models/stock-search-payload.model';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-filters',
  imports: [
    DsCheckboxModule,
    DsFormFieldModule,
    DsSelectModule,
    DsProgressCircleModule,
    DsLoadingAreaModule,
    FormsModule,
    DsButtonModule,
  ],
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FiltersComponent implements OnChanges {
  @Output() filtersChanged = new EventEmitter<RequestPayload>();
  @Output() modelSelected = new EventEmitter<any>();
  filters = {
    brand: '',
    version: '',
    model: '',
    interior: '',
    exterior: '',
    options: [] as string[],
    storageLocation: '',
    searchAllDSP: false,
  };
  isSearchAllStockChecked: boolean = false;
  brandOptions: { id: string; label: string }[] = [];
  filteredVersionOptions: { id: string; label: string }[] = [];
  filteredModelOptions: { id: string; label: string }[] = [];
  filteredModelOptionsReq: { id: string; label: string }[] = [];
  filteredOptions: { id: string; label: string }[] = [];
  locationOptions: { id: string; label: string }[] = [];
  filteredInteriorOptions: { id: string; label: string }[] = [];
  filteredExteriorOptions: { id: string; label: string }[] = [];
  versionOptions: Version[] = [];
  modelOptions: DealerModel[] = [];
  interiorOptions: ModelOption[] = [];
  exteriorOptions: ModelOption[] = [];
  includeOptions: ModelOption[] = [];
  excludeOptions: ModelOption[] = [];
  dealerCode: string = '';
  plantCode: string = '';
  isOptionsDisabled = true;
  @Input() criteriaData!: CriteriaResponse;
  @Input() externalData!: CriteriaResponse;
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Loading',
  };
  constructor(
    private readonly modelOptionsService: ModelOptionsService,
    private readonly loadingAreaService: DsLoadingAreaService
  ) {}

  onCheckboxChange(value: boolean): void {
    console.log(value);
    this.filters.searchAllDSP = value;
    this.isSearchAllStockChecked = value;
    this.onFiltersChange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['externalData'] && changes['externalData'].currentValue) {
      this.populateDropDowns(changes['externalData'].currentValue);
    }
  }

  private populateDropDowns(data: CriteriaResponse): void {
    this.brandOptions = data.dealerBrands.map((brand: DealerBrand) => ({
      id: brand.brandCode,
      label: brand.brandDescription,
    }));
    this.versionOptions = data.versions;
    this.modelOptions = data.dealerModels;
    this.locationOptions = data.storageLocations.map(
      (location: StorageLocation) => ({
        id: location.location,
        label: location.description,
      })
    );
    this.dealerCode = data.plantCode;
    this.plantCode = data.plant;
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  onBrandChange(event: SelectListOption | SelectListOption[] | null): void {
    if (event && !Array.isArray(event)) {
      this.filters.brand = event.id;
      this.filteredVersionOptions = this.versionOptions
        .filter(
          (version) => String(version.brand) === String(this.filters.brand)
        )
        .map((value) => ({ id: value.version, label: value.version }));
      this.filteredModelOptions = this.modelOptions
        .filter((model) => String(model.brand) === String(this.filters.brand))
        .map((value) => ({
          id: value.modelCode,
          label: value.modelCode + ' - ' + value.profileModelDescription,
        }));
      this.filteredModelOptionsReq = this.filteredModelOptions;
      this.onFiltersChange();
    } else {
      this.filters.brand = '';
      this.filters.version = '';
      this.filters.model = '';
      this.filteredVersionOptions = [];
      this.filteredModelOptions = [];
      this.filteredModelOptionsReq = [];
      this.isOptionsDisabled = true;
      this.interiorOptions = [];
      this.exteriorOptions = [];
      this.includeOptions = [];
      this.excludeOptions = [];

      this.onFiltersChange();
      console.error('Invalid event type or null event:', event);
    }
  }

  onVersionChange(event: SelectListOption | SelectListOption[] | null): void {
    if (event && !Array.isArray(event)) {
      this.filters.version = event.label;
      this.filteredModelOptions = this.modelOptions
        .filter((model) => model.version === this.filters.version)
        .map((model) => ({
          id: model.modelCode,
          label: model.modelCode + ' - ' + model.profileModelDescription,
        }));
      this.filteredModelOptionsReq = this.filteredModelOptions;
      this.onFiltersChange();
    } else {
      this.filters.version = '';
      this.filters.model = '';

      // Reset filtered versions and models based on brand only
      if (this.filters.brand) {
        this.filteredVersionOptions = this.versionOptions
          .filter(
            (version) => String(version.brand) === String(this.filters.brand)
          )
          .map((value) => ({ id: value.version, label: value.version }));
        this.filteredModelOptions = this.modelOptions
          .filter((model) => String(model.brand) === String(this.filters.brand))
          .map((value) => ({
            id: value.modelCode,
            label: value.modelCode + ' - ' + value.profileModelDescription,
          }));
        this.filteredModelOptionsReq = this.filteredModelOptions;
      } else {
        this.filteredVersionOptions = [];
        this.filteredModelOptions = [];
        this.filteredModelOptionsReq = [];
      }

      this.isOptionsDisabled = true;
      this.interiorOptions = [];
      this.exteriorOptions = [];
      this.includeOptions = [];
      this.excludeOptions = [];

      this.onFiltersChange();
    }
  }

  onModelChange(event: SelectListOption | SelectListOption[] | null): void {
    if (event && !Array.isArray(event)) {
      this.filters.model = event.id;
      this.filteredModelOptionsReq = [{ id: event.id, label: '' }];
      this.modelOptionsService.getModelOptions(this.filters.model).subscribe(
        (data: ModelOptionsResponse) => {
          console.log(data);
          this.interiorOptions = data.modelInteriorOptions;
          this.exteriorOptions = data.modelExteriorOptions;
          this.includeOptions = data.modelOptions;
          this.excludeOptions = [...data.modelOptions];
          this.isOptionsDisabled = false;
          this.mapInteriorAndExteriorOptions();
          this.onFiltersChange();
        },
        (error: unknown) => {
          // this.filters.model = '';
          this.onFiltersChange();
          console.error('Error fetching model options', error);
        }
      );
    }else{
      // Model cleared - reset model filter
      this.filters.model = '';
      this.filteredModelOptionsReq = this.filteredModelOptions; // fallback to filtered models based on version or brand
      this.isOptionsDisabled = true;  // disable options as no model selected?
      this.interiorOptions = [];
      this.exteriorOptions = [];
      this.includeOptions = [];
      this.excludeOptions = [];
      this.onFiltersChange();
    }
  }

  onFiltersChange(): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    const requestPayload = this.createRequestPayload();
    this.filtersChanged.emit(requestPayload);
    this.modelOptionsService.getModelOptions(this.filters.model).subscribe(
      (data: ModelOptionsResponse) => {
        console.log(data);
        this.interiorOptions = data.modelInteriorOptions;
        this.exteriorOptions = data.modelExteriorOptions;
        this.includeOptions = data.modelOptions;
        this.excludeOptions = [...data.modelOptions];
        this.isOptionsDisabled = false;
        this.mapInteriorAndExteriorOptions();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error: unknown) => {
        console.error('Error fetching model options', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  private createRequestPayload(): RequestPayload {
    return {
      storageLocation:
        this.filters.storageLocation === ''
          ? null
          : this.filters.storageLocation,
        dspStockFlag: this.filters.searchAllDSP ? 'X' : null,
      plantCode: this.plantCode,
      dealerCode: this.dealerCode,
     exterior: this.filters.exterior === ''
       ? null
       : this.exteriorOptions.find(opt => opt.optionCode === this.filters.exterior) ?? null,
     interior: this.filters.interior === ''
       ? null
       : this.interiorOptions.find(opt => opt.optionCode === this.filters.interior) ?? null,
      excludeOptions: [],
      includeOptions:
        this.filters.options && this.filters.options.length > 0
          ? this.includeOptions.filter((option) =>
              this.filters.options.includes(option.optionCode)
            )
          : [],
      materialNumbers: this.filteredModelOptionsReq.map((option) => option.id),
    };
  }
  get isBrandSelected(): boolean {
    return !!this.filters.brand;
  }
  private mapInteriorAndExteriorOptions(): void {
    this.filteredInteriorOptions = this.interiorOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));

    this.filteredExteriorOptions = this.exteriorOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));
    this.filteredOptions = this.includeOptions.map((option) => ({
      id: option.optionCode,
      label: option.optionCode + ' - ' + option.optionDescription,
    }));
  }
  clearFilters() {
    this.filters.brand = '';
    this.filters.version = '';
    this.filters.model = '';
    this.filters.interior = '';
    this.filters.exterior = '';
    this.filters.options = [];
    this.filters.storageLocation = '';
    this.isSearchAllStockChecked = false;
  }

  @Output() searchClicked = new EventEmitter<void>();
    showSearch: boolean = true;
  onSearchClick(): void {
      this.showSearch = false;
    this.searchClicked.emit();
  }

  modelSelectedCheck(event: SelectListOption | SelectListOption[] | null): void {
    this.modelSelected.emit(event);
  }

  onStorageLocation($event: SelectListOption | SelectListOption[] | null) {
    if($event === null) {
      this.filters.storageLocation = '';
      this.onFiltersChange();
      return;
    }
    this.filters.storageLocation = ($event as SelectListOption).id;
    this.onFiltersChange();

  }
  onInteriorChange($event: SelectListOption | SelectListOption[] | null) {
    if($event === null) {
      this.filters.interior = '';
      this.onFiltersChange();
      return;
    }
    this.filters.interior = ($event as SelectListOption).id;
    this.onFiltersChange();
  }

  onExteriorChange($event: SelectListOption | SelectListOption[] | null) {
    if($event === null) {
      this.filters.exterior = '';
      this.onFiltersChange();
      return;
    }
    this.filters.exterior = ($event as SelectListOption).id;
    this.onFiltersChange();
  }
}
